import { render } from "./PatchNotes.vue?vue&type=template&id=3ba972ca"
import script from "./PatchNotes.vue?vue&type=script&lang=js"
export * from "./PatchNotes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__